export default [
    {
      path: '/admin/customer-deposits',
      name: 'customer-topup',
      meta: { requiresAuth: true },
      component: () => import('@/pages/accounting/customer-topup')
    }
  ]
  